import { useMemo } from 'react'

import type { Hub, Part } from '@/services/schemas'
import { useHubStore } from '@/stores/HubStore'
import { ITEMS_PRESELECTED } from '@/util/Hardcoded'

export function getIncludedInList(hubs: Hub[], part: Part): string[] {
  return hubs
    .filter(hub =>
      hub.categories.some(category =>
        category.parts.some(partA =>
          partA.RNumber === part.RNumber && ITEMS_PRESELECTED.includes(partA.id),
        ),
      ),
    )
    .map(hub => hub.name)
}

export function useIncludedIn(part: Part) {
  const hubs = useHubStore(store => store.hubs)
  const includedIn = useMemo(() => getIncludedInList(hubs, part), [hubs, part])

  return includedIn.join(', ')
}
